import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPreProcessChecksByIdRequestSchema,
  TPreProcessChecksByIdResponseSchema,
} from "../preProcessChecksById/preProcessChecksById.schema";

export const preProcessChecksByIdV2 = (axios: IAxiosInstance) => {
  return async (body: TPreProcessChecksByIdRequestSchema) => {
    const response =
      await axios.noRetry.post<TPreProcessChecksByIdResponseSchema>(
        `/api/picard/preprocessChecksV2`,
        body
      );

    return response.data;
  };
};
